import { EnvironmentConfig } from './types';

export const stagingConfig: EnvironmentConfig = {
  // Environment identification
  environment: 'staging',
  
  // API Configuration - Staging API Gateway
  apiBaseUrl: 'https://api-staging.streaming-platform.com',
  apiTimeout: 15000,
  
  // Authentication Configuration (Staging Cognito Pool)
  cognitoUserPoolId: 'us-east-1_staging123456',
  cognitoUserPoolClientId: 'staging-client-id-123456',
  cognitoHostedUiUrl: 'https://staging-streaming-platform.auth.us-east-1.amazoncognito.com',
  cognitoRegion: 'us-east-1',
  
  // CDN and Asset Configuration - Staging CloudFront
  imagesCdnUrl: 'https://d1234567890abc.cloudfront.net/images',
  staticAssetsCdnUrl: 'https://staging.streaming-platform.com',
  
  // Feature Flags - Staging environment
  enableDebugMode: true,
  enableAnalytics: true,
  enablePerformanceMonitoring: true,
  enableErrorReporting: true,
  
  // Development Tools - Limited for staging
  enableDevTools: true,
  enableHotReload: false,
  
  // Security Configuration - Production-like security
  enableCSP: true,
  allowedOrigins: [
    'https://staging.streaming-platform.com',
    'https://api-staging.streaming-platform.com'
  ],
  
  // Performance Configuration - Production-like performance
  enableServiceWorker: true,
  enableLazyLoading: true,
  maxRetries: 3,
  retryDelay: 1500,
};